import React from 'react'
import logo from '../img/logo.png'
import react_logo from '../img/react_logo.png'
import tux_logo from '../img/linux_logo.png'
import db_logo from '../img/db_logo.png'
import banner from '../img/logo512.png'
import banner2 from '../img/nodejs_logo.png'





export const MainPage = () => {
    return (
        <div className="mui-container z-depth-1 ">
            <h5>NoSkiddie</h5>
            <div className="logoblock"><img src={tux_logo} alt="Logo" id="grayscale"/><img src={db_logo} alt="Logo" id="grayscale"/><img src={logo} alt="Logo" id="grayscale"/><img src={react_logo} alt="Logo" id="grayscale"/></div>
                   <div className="row">
                      <div className="col s12 m12">
                          <div className="imgbanner">
                          {/* <img className="banner" src={cssbanner} alt="banner" id="grayscale" /> */}
                          <div className="img-title">Hi! My name is Nikita Alekseev</div>
                          <div className="img-content">I am a system administrator and fullstack developer.</div>
                          </div>
                      </div>
                    <div className="col s12 m12 l6">                      
                      <div className="card">
                        <div className="card-img">
                        <img src={banner} alt="banner" />
                        <span className="card-title">REACT</span>
                          </div>
                        <div className="card-content"><p>Developing with best JS tools</p>
                          </div>
                      </div></div>
                    <div className="col s12 m12 l6">
                      <div className="card">
                        <div className="card-img">
                        <img src={banner2} alt="banner" />
                        <span className="card-title">NODE</span>
                          </div>
                        <div className="card-content"><p>Developing with best JS tools</p>
                          </div>
                      </div></div>
               </div>
        </div>
    )
    
}